export default __webpack_public_path__ + "static/media/email.ee736cec.svg";